import { render, staticRenderFns } from "./shop_mobile.vue?vue&type=template&id=27f0e568&scoped=true&"
import script from "./shop_mobile.vue?vue&type=script&lang=js&"
export * from "./shop_mobile.vue?vue&type=script&lang=js&"
import style0 from "./shop_mobile.vue?vue&type=style&index=0&id=27f0e568&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f0e568",
  null
  
)

export default component.exports